
import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { transformRequest } from "../../../utils/API/requestMiddleware";
import { encryptAES } from "../../../services/CryptoService";

const PaymentReconciliationApi = createApi({
    reducerPath: 'PaymentReconciliationApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        // Query to get all Dropdown for RecordList
        getAllDropDownsForTaskList: builder.query({
            query: () => ({
                url: `/Membership/GetAllDropDownsForTaskList`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        //Mutation to get Payment Reconcilation List
        getPaymentReconcilationList: builder.mutation({
            query: (details) => ({
                url: `/MembershipPayement/GetPaymentReconcilationList`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getPaymenetApprovalDetailsById: builder.query({
            query: (id) => ({
                url: `/MembershipPayement/GetPaymenetApprovalDetailsById?id=${encryptAES(id)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        AddPaymentReconciliationDetailByAdmin: builder.mutation({
            query: (details) => ({
                url: `/MembershipPayement/AddPaymentReconciliationDetailByAdmin`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getPaymenetApprovalDetailsList: builder.query({
            query: (details) => ({
                url: `/MembershipPayement/GetPaymenetApprovalDetailsList?id=${encryptAES(details.membershipPaymentId)}&id2=${encryptAES(details.bookingid)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        acceptAndApprovedIPASApplication: builder.mutation({
            query: (details) => ({
                url: `/MembershipPayement/AcceptAndApprovedIPASApplication`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        AcceptTotalPaidAmountInReconcilation: builder.query({
            query: (details) => ({
                url: `/EventManagement/AcceptTotalPaidAmountInReconcilation?id=${encryptAES(details?.BookingId)}&id2=${encryptAES(details?.CreatedBy)}&id3=${encryptAES(details?.CreatedAppId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        DeletePaymentReconcilationById: builder.query({
            query: (details) => ({
                url: `/MembershipPayement/DeletePaymentReconcilationById?id=${encryptAES(details?.id)}&id2=${encryptAES(details?.id2)}&id3=${encryptAES(details?.id3)}`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetOutstandingInvoicesList: builder.mutation({
            query: (details) => ({
                url: `/Finance/GetOutstandingInvoicesList`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        AddOutstandingInvoicePaymentProof: builder.mutation({
            query: (details) => ({
                url: `/Finance/AddOutstandingInvoicePaymentProof`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useLazyGetAllDropDownsForTaskListQuery,
    useGetPaymentReconcilationListMutation,
    useLazyGetPaymenetApprovalDetailsByIdQuery,
    useAddPaymentReconciliationDetailByAdminMutation,
    useLazyGetPaymenetApprovalDetailsListQuery,
    useAcceptAndApprovedIPASApplicationMutation,
    useLazyAcceptTotalPaidAmountInReconcilationQuery,
    useLazyDeletePaymentReconcilationByIdQuery,
    useGetOutstandingInvoicesListMutation,
    useAddOutstandingInvoicePaymentProofMutation,
} = PaymentReconciliationApi;

export default PaymentReconciliationApi;